import './RequestAccessFormComponent.scss';
import {Field, FieldProps, Form, Formik} from "formik";
import React, {useEffect} from "react";
import FormDebuggerComponent from "../../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikInputComponent from "../../../../shared/components/form-controls/formik-input/FormikInputComponent";
import FormikDatePickerComponent
    from "../../../../shared/components/form-controls/formik-date-picker/FormikDatePickerComponent";
import moment from "moment/moment";
import FormikPhoneInputComponent from "../../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import FormikSelectDropdownComponent
    from "../../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import AccordionComponent from "../../../../shared/components/accordion/accordionComponent";
import FormikRadioButtonComponent
    from "../../../../shared/components/form-controls/formik-radio-button/formikRadioButtonComponent";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";

interface RequestAccessFormComponentProps {
    requestAccessFormValidationSchema: any;
    requestAccessFormInitialValues: any;
    mutual_access_object: any;
    onSubmit: any;
    no_mutual_access_object: any;
    setIsRequestAccessDrawerOpen: any;
    setEditAccessStep?: any;
    onCancel?: () => void;
    accessType: string;
}

const RequestAccessFormComponent = (props: RequestAccessFormComponentProps) => {
    const {relationshipList} = useSelector((state: IRootReducerState) => state.staticData);
    const {
        requestAccessFormValidationSchema,
        requestAccessFormInitialValues,
        no_mutual_access_object,
        mutual_access_object,
        onSubmit,
        accessType,
        onCancel,
    } = props;


    return (
        <div className="request-access-form-component">
            {accessType === 'request' && <div className="request-access-description">
                Send a request to someone else to access and manage their account <br/> (i.e., to be registered as
                their
                caregiver).
            </div>}
            {
                accessType === 'grant' && <div className="request-access-description">
                    Send a request to someone else so they can access and manage <br/> your account.
                </div>
            }
            <div className={'profile-details-heading'}>Profile Details</div>
            {accessType === 'request' && <div className={'profile-details-subheading'}>
                Enter the following details of the profile you are
                requesting
                access to:
            </div>}
            {
                accessType === 'grant' && <div className="profile-details-subheading">
                    Enter the following details for the person you would like to grant access to:
                </div>
            }
            <Formik
                validationSchema={requestAccessFormValidationSchema}
                initialValues={requestAccessFormInitialValues}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                onSubmit={onSubmit}
            >
                {({values, validateForm, isValid, isSubmitting, dirty}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values, dirty]);
                    return (
                        <Form className="t-form" noValidate={true}>
                            <FormDebuggerComponent values={values} showDebugger={false}/>
                            <div className="request-access-form-controls">
                                <Field name={'client_id'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                id={'client_id_input'}
                                                label={''}
                                                placeholder={'Client ID*'}
                                                type={"text"}
                                                required={true}
                                                formikField={field}
                                                fullWidth={true}
                                            />
                                        )
                                    }
                                </Field>
                                <Field name={'first_name'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                id={'client_name_input'}
                                                label={''}
                                                placeholder={'First Name*'}
                                                type={"text"}
                                                required={true}
                                                formikField={field}
                                                fullWidth={true}
                                            />
                                        )
                                    }
                                </Field>
                                <Field name={'last_name'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                id={'client_name_input'}
                                                label={''}
                                                placeholder={'Last Name*'}
                                                type={"text"}
                                                required={true}
                                                formikField={field}
                                                fullWidth={true}
                                            />
                                        )
                                    }
                                </Field>
                                <Field name={'dob'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikDatePickerComponent
                                                placeholder={'Date of Birth*'}
                                                formikField={field}
                                                maxDate={moment()}
                                                required={true}
                                                fullWidth={true}
                                            />
                                        )
                                    }
                                </Field>
                                <Field name={'phone'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikPhoneInputComponent
                                                id={'phone_input'}
                                                label={''}
                                                required={true}
                                                placeholder={'Phone Number*'}
                                                formikField={field}
                                                fullWidth={true}
                                            />
                                        )
                                    }
                                </Field>
                                <div className={'relation-heading'}>Assign Relationship</div>
                                <div className={'relation-sub-heading'}>Choose how you are connected to the above
                                    mentioned profile.
                                </div>
                                <Field name={'relationship'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikSelectDropdownComponent
                                                options={relationshipList}
                                                placeholder={'Select Relationship'}
                                                formikField={field}
                                                fullWidth={true}
                                                isClearable={false}
                                            />
                                        )
                                    }
                                </Field>
                                <div className="permission-heading">Permissions</div>
                                <AccordionComponent
                                    title={<Field name={'permission_type'}>
                                        {
                                            (field: FieldProps) => (
                                                <FormikRadioButtonComponent
                                                    displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                    valueExtractor={(option: any) => option.code}
                                                    keyExtractor={(option: any) => option.code}
                                                    option={mutual_access_object}
                                                    formikField={field}
                                                    required={true}
                                                />
                                            )
                                        }
                                    </Field>}
                                >
                                    <div className="mutual-access-content-wrapper">
                                        <div className={'pdd-bottom-20'}>This Permission:</div>
                                        {accessType === 'request' && <ul className="pdd-left-25">
                                            <li>Gives the other person access to your account to book
                                                appointments and
                                                manage your account on your behalf.
                                            </li>
                                            <br/>
                                            <li>Gives you access to their account to book appointments
                                                and
                                                manage their
                                                account.
                                            </li>
                                            <br/>
                                            <li>Can be changed at any time.</li>
                                        </ul>
                                        }
                                        {
                                            accessType === 'grant' &&
                                            <ul className="pdd-left-25">
                                                <li>Gives the other person access to your account to book appointments
                                                    and manage your account on your behalf.

                                                </li>
                                                <br/>
                                                <li>Gives you access to their account to book appointments and manage
                                                    their account.
                                                </li>
                                                <br/>
                                                <li>Can be changed at any time.</li>
                                            </ul>
                                        }
                                    </div>
                                </AccordionComponent>
                                <div className="pdd-top-20">
                                    <AccordionComponent
                                        title={<Field name={'permission_type'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonComponent
                                                        displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.title)}`}
                                                        valueExtractor={(option: any) => option.code}
                                                        keyExtractor={(option: any) => option.code}
                                                        option={no_mutual_access_object}
                                                        formikField={field}
                                                        required={true}
                                                    />
                                                )
                                            }
                                        </Field>}
                                    >
                                        <div className="mutual-access-content-wrapper">
                                            <div className={'pdd-bottom-20'}>This Permission:</div>
                                            {accessType === 'request' && <ul className="pdd-left-25">
                                                <li>Gives you access to their account to book appointments and
                                                    manage their account.
                                                </li>
                                                <br/>
                                                <li>Does not give the other person permission to access your
                                                    account.
                                                </li>
                                                <br/>
                                                <li>Can be changed at any time.</li>
                                            </ul>}
                                            {
                                                accessType === 'grant' && <ul className="pdd-left-25">
                                                    <li>Gives the other person access to your account to book appointments
                                                        and manage your account on your behalf.
                                                    </li>
                                                    <br/>
                                                    <li>Does not give you access to their account.
                                                    </li>
                                                    <br/>
                                                    <li>Can be changed at any time.</li>
                                                </ul>
                                            }

                                        </div>
                                    </AccordionComponent>
                                </div>
                            </div>
                            <div className="t-form-actions mrg-top-50">
                                <ButtonComponent
                                    color={'accent'}
                                    variant={'outlined'}
                                    onClick={onCancel}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    color={'accent'}
                                    type={'submit'}
                                    disabled={!isValid}
                                    className={'mrg-left-10'}
                                    isLoading={isSubmitting}
                                    variant={'contained'}>
                                    Submit
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    );
}

export default RequestAccessFormComponent;
